import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import GreenButton from "../GreenButton/GreenButton";
import MobileMenu from "./MobileMenu";
import Logo from "./../../assets/images/MainLogo.svg";
import UserIcon from "./../../assets/images/profile.gif";
import UserNotificationIcon from "./../../assets/images/notifications.gif";
import UserBoxIcon from "./../../assets/images/orders.gif";
import UserSubscription from "./../../assets/images/subscription.gif";
import Login from "../../pages/Login/Login";
import UserMenu from "../UserMenu/UserMenu";
import { useLanguage } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";

const MainNavSection = ({
  isMobile,
  isTablet,
  mobileMenuOpen,
  toggleMobileMenu,
}) => {
  const location = useLocation();
  const [loginOpen, setLoginOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [activeItem, setActiveItem] = useState("");
  const [loginView, setLoginView] = useState("login");
  const { t, language, changeLanguage } = useLanguage();
  const { user, isAuthenticated, logout } = useAuth();

  // Get active navigation from URL path or clear it for unknown pages
  useEffect(() => {
    const path = location.pathname;
    const searchParams = new URLSearchParams(location.search);
    const typeParam = searchParams.get("type");

    let currentActive = "";

    // Only set active state if the current path matches a known nav item
    if (path === "/") {
      currentActive = "home";
    } else if (path.startsWith("/services") && typeParam === "subscription") {
      currentActive = "subscription";
    } else if (path.startsWith("/services")) {
      currentActive = "services";
    } else if (path.startsWith("/contact")) {
      currentActive = "contact";
    } else if (path.startsWith("/packages")) {
      currentActive = "packages";
    }

    // Clear active item in localStorage if on an unknown page
    if (currentActive) {
      localStorage.setItem("activeNavItem", currentActive);
    } else {
      localStorage.removeItem("activeNavItem");
    }

    setActiveItem(currentActive);
  }, [location]);

  const handleNavClick = (item) => {
    setActiveItem(item);
    localStorage.setItem("activeNavItem", item);
  };

  const handleLogout = async () => {
    await logout();
    setUserMenuOpen(false);
  };

  return (
    <div className="navbar__main" style={{ position: "relative" }}>
      <div className="container" style={{ position: "relative" }}>
        <Link className="navbar__main-logo" to="/">
          <img src={Logo} alt="Logo" />
        </Link>

        {/* Mobile menu button */}
        {(isMobile || isTablet) && (
          <button className="navbar__mobile-toggle" onClick={toggleMobileMenu}>
            <MenuIcon className="icon" />
          </button>
        )}

        {/* Desktop menu */}
        {!isMobile && !isTablet && (
          <>
            <ul className="navbar__main-nav">
              <li className={activeItem === "home" ? "active" : ""}>
                <Link to="/" onClick={() => handleNavClick("home")}>
                  {t("home")}
                </Link>
              </li>
              {/* <li className={activeItem === "services" ? "active" : ""}>
                <Link to="/services" onClick={() => handleNavClick("services")}>
                  {t("services")}
                </Link>
              </li> */}
              <li className={activeItem === "packages" ? "active" : ""}>
                <Link to="/packages" onClick={() => handleNavClick("packages")}>
                  {t("packages")}
                </Link>
              </li>
              <li className={activeItem === "contact" ? "active" : ""}>
                <Link to="/contact" onClick={() => handleNavClick("contact")}>
                  {t("contact")}
                </Link>
              </li>
            </ul>

            <div className="navbar__main-actions">
              {isAuthenticated && user ? (
                <div className="user-info">
                  <Link className="user" to="/subscriptions">
                    <img src={UserSubscription} alt={t("subscriptions")} />
                    <span>{t("subscriptions")}</span>
                  </Link>

                  <Link className=" user" to="/orders">
                    <img src={UserBoxIcon} alt={t("orders")} />
                    <span>{t("orders")}</span>
                  </Link>

                  <Link className=" user" to="/notifications">
                    <img src={UserNotificationIcon} alt={t("notifications")} />
                    <span>{t("notifications")}</span>
                  </Link>

                  <div className="user" onClick={() => setUserMenuOpen(true)}>
                    {user.profileImage ? (
                      <>
                        {" "}
                        <img
                          src={user.profileImage}
                          alt={user.name}
                          className="user-avatar"
                        />
                        <span>{t("profile")}</span>
                      </>
                    ) : (
                      <>
                        <img src={UserIcon} alt="User" className="user-icon" />
                        <span>{t("profile")}</span>
                      </>
                    )}
                  </div>
                </div>
              ) : (
                <>
                  <GreenButton
                    text={t("createAccount")}
                    size="medium"
                    variant="fill"
                    onClick={() => {
                      setLoginView("register");
                      setLoginOpen(true);
                    }}
                  />
                  <GreenButton
                    text={t("login")}
                    size="medium"
                    variant="outlined"
                    onClick={() => {
                      setLoginView("login");
                      setLoginOpen(true);
                    }}
                  />
                </>
              )}
            </div>
          </>
        )}

        {/* Mobile/Tablet Menu Overlay */}
        {(isMobile || isTablet) && (
          <MobileMenu
            isOpen={mobileMenuOpen}
            toggleMenu={toggleMobileMenu}
            activeItem={activeItem}
            setActiveItem={handleNavClick}
            isMobile={isMobile}
            currentLanguage={language}
            changeLanguage={changeLanguage}
            onLoginClick={(type) => {
              if (type === "login") {
                setLoginView("login");
                setLoginOpen(true);
              } else if (type === "register") {
                setLoginView("register");
                setLoginOpen(true);
              }
            }}
            onUserMenuClick={() => setUserMenuOpen(true)}
            onLogout={handleLogout}
          />
        )}
      </div>

      {/* Modal Components */}
      {loginOpen && (
        <Login
          open={loginOpen}
          onClose={() => setLoginOpen(false)}
          initialView={loginView}
        />
      )}
      {userMenuOpen && (
        <UserMenu
          open={userMenuOpen}
          onClose={() => setUserMenuOpen(false)}
          onLogout={handleLogout}
        />
      )}
    </div>
  );
};

export default MainNavSection;
